
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCommandTake as ObiCommandTakeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-command-take.js';
 
 
 

 
 export const ObiCommandTake = createComponent({
   react: React,
   tagName: 'obi-command-take',
   elementClass: ObiCommandTakeElement,
   events: {
     
   }
  });
 
 